package com.xtream.composeapp.viewmodel



import androidx.compose.ui.graphics.Color
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.xtream.composeapp.SharedBuildKonfig
import com.xtream.core_model.dto.MovieSubtitle
import com.xtream.data_kmp.PreferencesRepo
import com.xtream.data_kmp.db.repo.UserRepo
import com.xtream.data_kmp.db.repo.VodStreamsRepository
import com.xtream.data_kmp.dto.TMDBMovieImages
import com.xtream.data_kmp.dto.VodInfo
import com.xtream.data_kmp.dto.VodStream
import com.xtream.data_kmp.dto.toVodStream
import com.xtream.data_kmp.remote.createApiService
import com.xtream.data_kmp.util.extension.addTMDBPrefixImageURL
import io.ktor.client.call.body
import io.ktor.client.statement.HttpResponse
import io.ktor.http.isSuccess
import kotlinx.coroutines.CoroutineExceptionHandler
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.collectLatest
import kotlinx.coroutines.flow.firstOrNull
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.launch
import kotlinx.serialization.ExperimentalSerializationApi

class VodInfoViewModel (
    private val userRepo: UserRepo,
    private val preferencesRepo: PreferencesRepo,
    private val tvStreamsRepo: VodStreamsRepository,

    vodId: Int?


) : ViewModel() {


    private val _streamTitleLogoState = MutableStateFlow<String?>(null)
    val streamTitleLogoState: StateFlow<String?> = _streamTitleLogoState

    private val _streamState = MutableStateFlow<VodStream?>(null)
    val streamState: StateFlow<VodStream?> = _streamState
    private val _recommendedItems = MutableStateFlow<List<VodStream>>(emptyList())
    val recommendedItems: StateFlow<List<VodStream>> = _recommendedItems
    val vodInfoStateFlow= MutableStateFlow<VodInfo?>(null)


    private val _streamSubtitleState = MutableStateFlow<MovieSubtitle?>(null)
    val streamSubtitleState: StateFlow<MovieSubtitle?> = _streamSubtitleState
    init {
        loadInfo(vodId)
        loadRecommendations( vodId)
    }


    @OptIn(ExperimentalSerializationApi::class)
    @Deprecated("Use loadInfo")
    fun loadVodInfo(username:String, password:String, serverUrl:String?, vodId: Int?, onSuccess:suspend (vodInfo: VodInfo?)->Unit) {

        if (vodId == null) {
            return
        }
        viewModelScope.launch(Dispatchers.Default) {
            vodInfoStateFlow.emit(null)
            try {

 /*
            val client= HttpClient(OS.Android){
                if (Build.VERSION.SDK_INT <= Build.VERSION_CODES.N) {
                    engine {
                        sslManager = { httpsURLConnection ->
                            httpsURLConnection.sslSocketFactory =
                                KtorSslHelper.getUnsafeSSLSocketFactory()
                            httpsURLConnection.hostnameVerifier = HostnameVerifier { _, _ -> true }
                        }
                    }
                }
                install(ContentNegotiation){

                    json(kotlinx.serialization.json.Json {
                        ignoreUnknownKeys = true
                        isLenient = true
                        encodeDefaults = false
                        explicitNulls=false

                    })
                }
            }*/
          //  Log.d("#Request:", "loadVodInfo_id: $vodId, $username, $password")
           // Log.d("#Request:", "loadVodInfo URL: $serverUrl${BuildConfig.SERVER_API} $vodId, $username, $password")
            //val millis= Clock.System.now().toEpochMilliseconds()
           // val apiService= ApiService.create()
            // val liveStreams = apiService.getVodStreams().body<String>()
           val client = createApiService("$serverUrl${SharedBuildKonfig.SERVER_API}", username, password)
            val response = client.getVodInfo(vodId)

            if (response.status.isSuccess()) {
             //   Log.d("#Response:", ((Clock.System.now().toEpochMilliseconds() - millis) / 1000).toString()+" Sec")

                val vodInfo = response.body<VodInfo?>()
              //  Log.d("#Response:", "Serialization: "+((Clock.System.now().toEpochMilliseconds() - millis) / 1000).toString()+" Sec, body:\n${vodInfo}")

                vodInfoStateFlow.emit(vodInfo)
                onSuccess.invoke(vodInfo)


                }


            }catch (e:Exception) {



                onSuccess.invoke(VodInfo(null,null))
            }


        }
    }

     fun loadInfo(vodId: Int?, onSuccess: suspend (vodInfo: VodInfo?) -> Unit={}) {
         if (vodId == null) return
         viewModelScope.launch {
             val serverUrl = userRepo.getUserServerUrl()
             val username = userRepo.getLastLoggedInUser()?.userInfo?.username?:""
             val password = userRepo.getLastLoggedInUser()?.userInfo?.password?:""
             loadVodInfo(username, password, serverUrl, vodId, onSuccess = {vodInfo ->
                 getTMDBLogo(vodInfo?.info?.tmdb_id,
                     onFinished = {
                         _streamTitleLogoState.value=it
                     },
                     onError = {
                         _streamTitleLogoState.value=null

                     })
                 onSuccess.invoke(vodInfo)
                 loadSubtitle( vodInfo?.info?.tmdb_id)
                 _streamState.value = vodInfo?.movie_data?.toVodStream()


             })
         }
    }

    private val coroutineExceptionHandler = CoroutineExceptionHandler { _, throwable ->
        throwable.printStackTrace()
    }
    private suspend fun getSubtitleServer() = preferencesRepo.readFromDataStore.map { it.subtitleServer }.firstOrNull()

    private fun loadSubtitle(tmdbId: String?) {
        viewModelScope.launch(Dispatchers.Default + coroutineExceptionHandler) {
            try {
                error("loadSubtitle not implemented")/*
                if (tmdbId == null) throw Exception("No TMDB ID for subtitles")
                val client = ApiService.create(getSubtitleServer()?:"")
                val subtitleResponse = client.getSubtitle(
                    tmdbId,
                    preferencesRepo.readFromDataStore.map { it.subtitleKey }.firstOrNull(),
                    BuildConfig.APPLICATION_ID
                )

                if (subtitleResponse.status.isSuccess()) {
                    subtitleResponse.body<MovieSubtitle>().let {
                        Log.d("Subtitle", it.toString())
                        _streamSubtitleState.value = it
                    }
                } else {
                    throw Exception("Error code ${subtitleResponse.status}")
                }
*/

            } catch (e: Exception) {
               // Log.d("SubtitleError", e.toString())
            }
        }
    }


    private val _backdropColor = MutableStateFlow<Color?>(null)
    val backdropColor = _backdropColor.asStateFlow()
   suspend fun getTMDBLogo(tmdbId:String?,  onFinished:(String?)->Unit, onError:(String)->Unit){

      try {

          val tmdbKey: String? =  preferencesRepo.getPref( PreferencesRepo.SERVER_TMDB_KEY)
          if (tmdbId == null) throw Exception("No TMDB ID")
          val apiService = createApiService("https://api.themoviedb.org/3/movie/$tmdbId/images")
           val response: HttpResponse = apiService.getTmdbMovieLogo(tmdbKey?:"")

          //println("++++ ${response}")
       val tmdbLogoURl=  response.body<TMDBMovieImages>().logos?.let {
             val logo= it.firstOrNull {itm->itm?.iso6391?.lowercase()=="en" }?: it.firstOrNull()
                 logo?.filePath?.addTMDBPrefixImageURL()
          }

          if (tmdbLogoURl == null) throw Exception("No TMDB Logo")
          onFinished.invoke(tmdbLogoURl)
       }catch (e:Exception){
            onError.invoke(e.message.toString())
      }

    }

    fun loadRecommendations(id: Int?) {
if (id==null||id==-1) return
        viewModelScope.launch {
            val stream = tvStreamsRepo.getVodByStreamId(id)
            stream?.let {
                val recommended = tvStreamsRepo.getRecommendationsList(
                    stream.categoryId,
                    limit = 15,
                    excludeIds = listOf(stream.streamId)
                )
                recommended.collectLatest {
                    _recommendedItems.value = it
                }

            }
        }
    }
}
